import { render } from "./assignments.vue?vue&type=template&id=6370a445"
import script from "./assignments.vue?vue&type=script&lang=js"
export * from "./assignments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__